const WISHLIST = {
  ADD_TO_MY_WISHLIST: 'Adicionar a minha Lista',
  CONFIGS: 'Editar',
  COUPON: {
    ADD_CATEGORY_OR_STORE_LABEL: 'Digite a categoria ou nome da loja',
    EMAIL_SUBSCRIPTION_LABEL: 'Quero receber alertas de cupons por email',
  },
  DEFINITION:
    'E se não encontrar o que procura, crie sua lista de desejos e receba alertas gratuitos assim que o produto aparecer em promoção.',
  EDIT_MY_WISHLIST: 'Editar minha lista',
  EDIT_OFFER_KEYWORD: {
    CATEGORIES_PLACEHOLDER:
      'Selecione uma categoria para restringir o envio de alertas',
    EDIT_INPUT_LABEL: 'Termo',
    KEYWORD_IS_REQUIRED: 'O termo para receber alertas de oferta é obrigatório',
    MAX_PRICE_LABEL: 'Preço máximo',
    MIN_PRICE_HAS_TO_BE_LESSER_THAN_MAX:
      'O preço mínimo deve ser menor que o máximo para receber alertas',
    MIN_PRICE_LABEL: 'Preço mínimo',
    PRICE_INPUT_PLACEHOLDER: '0,00',
    PRICE_RANGE: 'Faixa de preço',
    TITLE: 'Editar termo',
    LOWEST_PRICE_OFFERS_ONLY_LABEL:
      'Quero receber apenas ofertas com o menor preço',
  },
  GENERIC: {
    SUGGESTIONS: 'Escolha algumas sugestões',
  },
  HOW_IT_WORKS:
    'Adicione termos a sua lista de desejos para receber alertas gratuitos quando uma nova oferta aparecer no Promobit.',
  OFFER: {
    ADD_KEYWORD_LABEL: 'Digite o termo desejado para receber alertas',
    DESCRIPTIONS: {
      ONLY_LOWEST_PRICE_OFFERS: 'Apenas ofertas com menor preço',
      ALL_OFFERS: 'Todas as ofertas',
    },
    EMAIL_SUBSCRIPTION_LABEL: 'Quero receber alertas de ofertas por email',
    INTRO:
      'Crie sua lista com termos relacionados aos produtos que você está de olho e receba alertas quando eles aparecerem por aqui!',
    REMOVE_KEYWORD: 'Remover termo',
    WHEN_FINISHED_TO_ADD_WISHLIST: 'Avise-me quando voltar',
  },
  SUGGESTIONS: 'Algumas sugestões que podem te interessar',
  TABS: {
    COUPON: 'Cupom',
    OFFER: 'Oferta',
  },
  TITLE: 'Lista de desejos',
  TOAST: {
    ERROR_WHEN_ATTEMPTING_ADD_KEYWORD:
      'Não foi possível adicionar o termo a Lista de Desejos no momento',
    ERROR_WHEN_ATTEMPTING_REMOVE_KEYWORD:
      'Não foi possível remover o termo da Lista de Desejos no momento',
    KEYWORD_ADDED_WITH_SUCCESSFULLY: 'Alerta adicionado com sucesso',
    KEYWORD_ALREADY_ADDED: 'Termo já foi adicionado a sua Lista de Desejos',
    KEYWORD_REMOVED_WITH_SUCCESSFULLY: 'Alerta desativado',
  },
};

export default WISHLIST;
